// Load all the controllers within this directory and all subdirectories.
// Controller files must be named *_controller.js.

import { Application } from "stimulus"
import { definitionsFromContext } from "stimulus/webpack-helpers"
import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import vNotify from "./vanilla-notify"
import BSN from "bootstrap.native"

const application = Application.start()
const context = require.context("controllers", true, /_controller\.js$/)

application.load(definitionsFromContext(context))

ActiveStorage.start()
Rails.start()
window.Rails = Rails;

// window click
// Close the dropdown if the user clicks outside of it.
// Flatpickr calendars are rendered in <body> (outside the dropdown) and open on mousedown/focus,
// so a click that started inside the dropdown or happens in a calendar must keep the dropdown open.
const KEEP_DROPDOWN_OPEN_SELECTOR = '.drop-menu, .flatpickr-calendar';
let mousedown_target = null;

document.addEventListener("mousedown", function (event) {
  mousedown_target = event.target;
}, true);

window.onclick = function (event) {
  // The target belongs to this click only, so it is consumed here. A click without a mousedown
  // (Enter from the keyboard, a programmatic .click()) has detail === 0 and must not reuse an old one.
  const started_at = event.detail > 0 ? mousedown_target : null;
  mousedown_target = null;

  const started_inside = started_at instanceof Element && started_at.closest(KEEP_DROPDOWN_OPEN_SELECTOR) !== null;
  const clicked_outside = event.target.closest(KEEP_DROPDOWN_OPEN_SELECTOR) === null && !started_inside;

  if (clicked_outside || event.target.matches('.drop-close')) {
    if (!event.target.matches('.drop-toggle')) {
      var dropdowns = document.getElementsByClassName("drop-menu");

      for (var i = 0; i < dropdowns.length; i++) {
        var openDropdown = dropdowns[i];
        if (openDropdown.classList.contains('show')) {
          openDropdown.classList.remove('show');
        }
      }
    }
  }
}

window.bsn = BSN
